<template>
    <div v-if="is_load">
        <PacmanLoader v-if="false" />
        <MiniLoader />
    </div>
    <div v-else-if="access_denied">
        <h2>הגישה נדחתה</h2><br />
        נראה שאין לך הרשאות לצפות בעמוד זה.<br />
        במידה וקיבלת הודעה זאת בטעות, אנא צור קשר עם מנהלי האתר.
    </div>
    <div class="" v-else-if="store.is_login">
        <div class="row">
            <div class="form-group">
                <label>תאריך</label>
                <DatePicker v-model="date" range :enableTimePicker="false" format="dd/MM/yyyy" :dark="store.dark_mode"
                    locale="en" :cancelText="store.dp_lang.cancelText" :selectText="store.dp_lang.selectText"
                    @update:model-value="firstDataLoad"></Datepicker>
            </div>
        </div>
        <br />
        <div v-if="is_loading">
            <MiniLoader />
        </div>
        <div v-else>
            <DataTable class="display" :columns="columns" :data="rows" ref="table" :options="{
                language: store.dataTable.language,
                lengthMenu: store.dataTable.lengthMenu,
                iDisplayLength: store.dataTable.iDisplayLength,
                buttons: store.dataTable.buttons,
                order: [0, 'desc'],
                responsive: true,
                dom: 'Bftip'
            }">
                <thead>
                    <tr>
                        <th>מפעל</th>
                        <th>כמות הזמנות</th>
                        <th>פריטים</th>
                    </tr>
                </thead>
            </DataTable>
        </div>
    </div>
    <div v-else>
        <NotLogin />
    </div>
</template>
<style scoped>
@import 'datatables.net-dt';
@import "//cdn.datatables.net/buttons/1.5.1/css/buttons.dataTables.min.css";
</style>
<script>
import { ref } from 'vue';
import axios from 'axios'
import { log } from '@/utils.js'
import PacmanLoader from '@/components/loaders/PacmanLoader.vue';
import MiniLoader from '@/components/loaders/MiniLoader.vue';
import { store } from '@/store'
import jQuery from "jquery";
import DataTable from 'datatables.net-vue3'
import DataTablesLib from 'datatables.net';
import 'datatables.net-responsive';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import moment from 'moment'

const $ = jQuery;
window.$ = $;



DataTable.use(DataTablesLib);
export default {
    el: 'ReservationList',
    components: {
        PacmanLoader,
        MiniLoader,
        DataTable,
    },
    mounted() {
        this.date = ref();
        this.date = [this.store.getDate.startDate, this.store.getDate.endDate];

        this.firstDataLoad();

    
    },
    computed: {
    },

    data() {
        return {
            store,
            tender: {},
            error: {},
            storage: {},
            is_load: true,
            is_loading: false,
            access_denied: false,

            rows: [],
            columns: [
                { data: 'factory_name' },
                { data: 'reservation_count' },
                { data: 'product_info' },

            ],
        }
    },
    methods: {
        firstDataLoad: function () {

            this.is_loading = true;
            this.rows = [];
            this.store.getDate.startDate = this.date[0];
            this.store.getDate.endDate = this.date[1];

            let formData = new FormData();
            formData.append('key', sessionStorage.getItem('key'));
            formData.append('date_start', moment(this.date[0]).format("YYYY-MM-DD"));
            formData.append('date_end', moment(this.date[1]).format("YYYY-MM-DD"));
            axios.post(store.api_url + '/reservation/get_factory_list', formData).then(response => {
                let res = response.data.data;
                Object.entries(res.results).forEach(([factory_id, obj]) => {

                    const product_info = Object.entries(obj)
                        .map(([id, value]) => {
                            const product = res.products[id];
                            if (!product) return '';

                            let unit = '';
                            if (product.product_unit)
                                unit = `  &nbsp;&nbsp;&nbsp;<small>(${product.product_unit})</small>`;
                            return `<strong>${product.product_name}</strong>: ${value}${unit}<br />`;
                        })
                        .join('');

                    Object.assign(obj, {
                        factory_name: res.factories[factory_id],
                        reservation_count: res.factory_count[factory_id],
                        product_info
                    });

                    this.rows.push(obj);
                });

                this.is_loading = false;
                this.is_load = false;


            }).catch(function (error) {
                log(error);
            });
        },


        test: function () {
            this.rows = [];

        },

    }
}


</script>
